export default __webpack_public_path__ + "images/5a8a8b9faa98620c9d0bcbcac593373f.svg";